import React from 'react';
import IHasItemDataProps from './IHasItemDataProps';
import IHasItemEventProps from './IHasItemEventProps';
import { IItemWithoutShowSellerProps } from './IItemProps';
import CdNumberInput from '../CdNumberInput.styles';
import { createOnChangeHandlerGenerator } from '../utilities/createOnChangeHandlerGenerator';
import { ISellerCreditViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';

interface ISellerCreditProps
  extends IItemWithoutShowSellerProps,
    IHasItemDataProps<ISellerCreditViewItem>,
    IHasItemEventProps<ISellerCreditViewItem> {
  onFocus?: () => void;
  onBlur?: (event: React.FocusEvent) => void;
}

export default class SellerCredit extends React.Component<ISellerCreditProps> {
  constructor(props: ISellerCreditProps) {
    super(props);

    this.onBlur = this.onBlur.bind(this);
    this.onFocus = this.onFocus.bind(this);
  }

  public render() {
    const { data, onChange, hasEditPermissions } = this.props;
    const generateDefaultOnChangeHandler = createOnChangeHandlerGenerator(data, onChange);
    const sellerAtClosingOnChange = generateDefaultOnChangeHandler('seller_at_closing');
    return (
      <div className="cost-data__row cost-data__aligned-row">
        <span className="cost-data__content-cell cost-data__content-row-number" />
        <span className="cost-data__content-cell cost-data__content-name">Seller Credit</span>
        <span className="cost-data__content-cell cost-data__content-amount">
          <CdNumberInput
            mode="currency"
            onChange={sellerAtClosingOnChange}
            onBlur={this.onBlur}
            onFocus={this.onFocus}
            value={this.props.data.seller_at_closing}
            readOnly={!hasEditPermissions}
            debounceOnValueChange
          />
        </span>
        <span className="cost-data__content-cell cost-data__content-control" />
      </div>
    );
  }

  private onBlur(event: React.FocusEvent) {
    const { onBlur } = this.props;
    if (onBlur) {
      onBlur(event);
    }
  }

  private onFocus() {
    const { onFocus } = this.props;
    if (onFocus) {
      onFocus();
    }
  }
}
